import React, { useState } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";

import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import MuiButton from "@material-ui/core/Button";

import DeleteIcon from "@material-ui/icons/Delete";

import { isPromise } from "../utils/helpers";

const useStyles = makeStyles(theme => ({
  root: {
    display: "inline-block",
  },
  width: {
    width: 400,
  },
  deleteButton: {
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: fade(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
}));

const ConfirmButton = props => {
  const { label, icon, onConfirm, onCancel, confirmTitle, confirmMessage, ...rest } = props;

  const classes = useStyles();
  const [dialogActive, setDialogActive] = useState(false);

  const handleClose = async event => {
    if (isPromise(onCancel)) {
      await onCancel(event);
    } else if (typeof onCancel === "function") {
      onCancel(event);
    }
    setDialogActive(false);
  };

  const handleSubmit = async event => {
    if (isPromise(onConfirm)) {
      await onConfirm(event);
      setDialogActive(false);
    } else if (typeof onConfirm === "function") {
      onConfirm(event);
      setDialogActive(false);
    }
  };

  return (
    <div className={classes.root}>
      <Dialog open={dialogActive} onClose={handleClose}>
        <DialogTitle className={classes.width}>{confirmTitle}</DialogTitle>
        {confirmMessage && (
          <DialogContent>
            <DialogContentText>{confirmMessage}</DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          <MuiButton onClick={handleClose} color="primary" variant="text">
            Cancel
          </MuiButton>
          <MuiButton onClick={handleSubmit} color="primary" variant="contained" autoFocus>
            {label}
          </MuiButton>
        </DialogActions>
      </Dialog>

      <MuiButton
        onClick={_ => setDialogActive(true)}
        className={classes.deleteButton}
        variant="contained"
        startIcon={icon}
        {...rest}>
        {label}
      </MuiButton>
    </div>
  );
};

ConfirmButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.any,
  confirmTitle: PropTypes.string,
  confirmMessage: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

ConfirmButton.defaultProps = {
  label: "Delete",
  icon: <DeleteIcon />,
  confirmTitle: "Delete Record?",
};

export default ConfirmButton;
